import { SequencesMinigame } from '@phaser/minigames/sequences';
import { SlotsMinigame } from '@phaser/minigames/slots';
import { Game } from '@phaser/scenes/Game';
import { DEPTH } from '@phaser/data/depth';

export class MinigameSystem {
  public get hasTimeLeft() {
    return this._timeLeft > 500;
  }

  private _sequences = new SequencesMinigame();
  private _slots = new SlotsMinigame();
  private _scene = Game.current;
  private _timeLeft = 0;
  private _cardId = '';

  private _background?: Phaser.GameObjects.Rectangle;
  private _closeButton?: Phaser.GameObjects.Image;
  private _timer?: Phaser.GameObjects.Text;

  constructor() {}

  public startHacking(cardId: string) {
    if (this._cardId) {
      this._scene.multiplayerSystem.stopHacking(cardId, false);
      return;
    }

    this._cardId = cardId;
    this._timeLeft = 20_000;
    this._createBackground();
    this._createTimer();

    if (Math.random() > 0.5) {
      this._sequences.start();
    } else {
      this._slots.start();
    }
  }

  public update(_time: number, delta: number) {
    this._updateTimer(delta);
    this._slots.update(_time, delta);
  }

  public success() {
    this._stopHacking(true);
  }

  private _stopHacking(success = false) {
    this._scene.multiplayerSystem.stopHacking(this._cardId, success);

    this._timeLeft = 0;

    this._sequences.destroy();
    this._slots.destroy();

    this._background?.destroy();
    this._background = undefined;
    this._closeButton?.destroy();
    this._closeButton = undefined;
    this._timer?.destroy();
    this._timer = undefined;

    setTimeout(() => {
      this._cardId = '';
    }, 250);
  }

  private _createBackground() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;
    const height = camera.displayHeight;

    this._background = this._scene.add.rectangle(0, 0, width, height, 0x000000, 0.9)
      .setDepth(DEPTH.MINIGAME_BACKGROUND)
      .setOrigin(0);
    this._closeButton = this._scene.add.image(width - 50, 30, 'sprites', 'close')
      .setDepth(DEPTH.MINIGAME)
      .setScale(0.15)
      .setInteractive();

    this._closeButton.on('pointerdown', () => {
      this._stopHacking();
    });
  }

  private _createTimer() {
    this._timer = this._scene.add.text(40, 30, '00:00', {
        fontFamily: 'Kode Mono Variable',
        fontSize: '32px',
        color: '#ffffff',
        resolution: 3,
      })
      .setOrigin(0, 0.5)
      .setDepth(DEPTH.MINIGAME);
  }

  private _updateTimer(delta: number) {
    if (this._timeLeft <= 0) return;

    this._timeLeft -= delta;
    if (this._timeLeft <= 0) return this._stopHacking();

    const seconds = Math.floor(this._timeLeft / 1000);
    const milliseconds = Math.floor(this._timeLeft % 1000);
    const ss = seconds.toString().padStart(2, '0');
    const mmm = milliseconds.toString().padStart(3, '0');
  
    this._timer?.setText(`${ss}:${mmm}`);
  }
}